import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class QaDecisionRejectionReason implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;

  constructor(
    private fId: string,
    private fQaDecision: string,
    private fRejectionReason: string
  ) {
    [fId, fQaDecision, fRejectionReason].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get qaDecision(): string {
    return this.fQaDecision;
  }

  get rejectionReason(): string {
    return this.fRejectionReason;
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }
}
